import React, { useState } from 'react';
import { Table, Button, Space, message, Modal, Form, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';

const { TextArea } = Input;

const TermsAndCondition = () => {
    const [terms, setTerms] = useState([
        {
            id: 1,
            title: 'Terms of Service',
            content: 'These are the terms and conditions for using our service...',
            updatedAt: '2025-01-15',
        },
        {
            id: 2,
            title: 'User Agreement',
            content: 'By using our platform, you agree to the following terms...',
            updatedAt: '2025-01-10',
        },
    ]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingTerm, setEditingTerm] = useState(null);
    const [form] = Form.useForm();

    const handleAddTerm = () => {
        setEditingTerm(null);
        setIsModalVisible(true);
        form.resetFields();
    };

    const handleEditTerm = (record) => {
        setEditingTerm(record);
        setIsModalVisible(true);
        form.setFieldsValue({
            title: record.title,
            content: record.content,
        });
    };

    const handleDeleteTerm = (id) => {
        setTerms(terms.filter(term => term.id !== id));
        message.success('Term deleted successfully');
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setEditingTerm(null);
        form.resetFields();
    };

    const handleModalOk = async () => {
        try {
            const values = await form.validateFields();

            if (editingTerm) {
                // Update existing term
                setTerms(terms.map(term =>
                    term.id === editingTerm.id
                        ? {
                            ...term,
                            title: values.title,
                            content: values.content,
                            updatedAt: new Date().toISOString().split('T')[0],
                        }
                        : term
                ));
                message.success('Term updated successfully');
            } else {
                // Add new term
                const newTerm = {
                    id: terms.length > 0 ? Math.max(...terms.map(t => t.id)) + 1 : 1,
                    title: values.title,
                    content: values.content,
                    updatedAt: new Date().toISOString().split('T')[0],
                };
                setTerms([...terms, newTerm]);
                message.success('Term added successfully');
            }

            setIsModalVisible(false);
            setEditingTerm(null);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Content',
            dataIndex: 'content',
            key: 'content',
            ellipsis: true,
            render: (text) => text.length > 100 ? `${text.substring(0, 100)}...` : text,
        },
        {
            title: 'Last Updated',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: 150,
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => handleEditTerm(record)}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this term?"
                        onConfirm={() => handleDeleteTerm(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            icon={<DeleteOutlined />}
                            size="small"
                            danger
                        >
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Terms and Condition</h1>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddTerm}
                >
                    Add New Term
                </Button>
            </div>
            <Table
                columns={columns}
                dataSource={terms}
                rowKey="id"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} terms`,
                }}
            />

            <Modal
                title={editingTerm ? "Edit Term" : "Add New Term"}
                open={isModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText={editingTerm ? "Update Term" : "Add Term"}
                cancelText="Cancel"
                width={700}
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        label="Title"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter term title!',
                            },
                        ]}
                    >
                        <Input placeholder="Enter term title" />
                    </Form.Item>

                    <Form.Item
                        label="Content"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter term content!',
                            },
                        ]}
                    >
                        <TextArea
                            rows={8}
                            placeholder="Enter term content"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default TermsAndCondition;

